/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateInChatPrompt} from '../api'

export const useMutationUpdateInChatPrompt = createReactQueryMutationHook('updateInChatPrompt', updateInChatPrompt)
